import { Component, h, Prop, Element, Listen, State } from '@stencil/core';
import { _BREAKPOINTS_ } from 'utils';

@Component({
    tag: 'kdx-overlay-hero',
    styleUrl: 'kdx-overlay-hero.scss'
})
export class KdxOverlayHero {

    @Element() root: HTMLElement;

    @Prop() desktopImg: string;
    @Prop() mobileImg: string;
    @Prop() imgAlt: string;

    @State() bg: string; 

    @Listen('resize', {target: "window"})
    resizeHandler() {
        this.setBG();
    }

    componentWillLoad() {
        this.setBG();
    }

    setBG() {
        this.bg = (!this.mobileImg || window.innerWidth >= _BREAKPOINTS_['md']) ? this.desktopImg : this.mobileImg;
    }

    render() {
        return (
            <section class="kdx-overlay-hero" aria-label="page banner with overlay">
                <div class="container-fluid">
                    <slot />
                </div>
                
                <img src={this.bg} class="hero-img" alt={this.imgAlt} />
                
            </section>
        );
    }
}
